import { render, staticRenderFns } from "./acceso-cuenta-modal.vue?vue&type=template&id=18bcbad8&"
import script from "./acceso-cuenta-modal.vue?vue&type=script&lang=js&"
export * from "./acceso-cuenta-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports